import { render } from "./BusRouteInfoDialog.vue?vue&type=template&id=24a1c2be&ts=true"
import script from "./BusRouteInfoDialog.vue?vue&type=script&lang=ts"
export * from "./BusRouteInfoDialog.vue?vue&type=script&lang=ts"

import "./BusRouteInfoDialog.vue?vue&type=style&index=0&id=24a1c2be&lang=scss"

import exportComponent from "/Users/phoebe/projects/find-bus-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__